
































import Vue from 'vue'

interface Option {
  text: string
  value: string | number
}
export default Vue.extend({
  props: {
    // must be included in props
    value: {
      //@ts-ignore
      type: null as () => any,
      default: '',
    },
    selectClass: {
      type: String as () => string,
      default: '',
    },
    ulClass: {
      type: String as () => string,
      default: '',
    },
    placeholder: {
      type: String as () => string,
      default: '',
    },
    options: {
      type: Array as () => Option[],
      default: () => [],
    },
    disabled: {
      type: Boolean as () => boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: '' as string | number,
    showList: false,
  }),
  computed: {
    noInput(): boolean {
      return this.innerValue === ''
    },
    displayValue(): string {
      return this.noInput
        ? this.placeholder
        : this.options.find((op) => op.value === this.innerValue)?.text || ''
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    toggleList(): void {
      if (this.disabled) return
      this.showList = !this.showList
      // 選択中のところにスクロールする
      Vue.nextTick(() => {
        const ul: HTMLElement = this.$refs.list as HTMLElement
        const active: HTMLElement = ul.getElementsByClassName(
          'active'
        )[0] as HTMLElement

        if (!ul || !active) return

        ul.scrollTop = active.offsetTop
      })
    },
    optionClicked(option: Option) {
      if (this.disabled) return

      this.setValue(option)
      this.showList = false
    },
    setValue(option: Option) {
      this.innerValue = option.value
    },
  },
})
